import { useState, type FormEvent } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Button, Field, Alert } from "@evolua/ui";
import { AuthApiError } from "../../auth/auth-api.js";
import { useAuth } from "../../auth/AuthContext.js";
import { getAuthMode } from "../../auth/config.js";
import { getChallenge } from "../../auth/token-storage.js";
import { AuthLayout } from "./AuthLayout.js";

export function MfaChallengePage() {
  const mode = getAuthMode();
  const auth = useAuth();
  const navigate = useNavigate();
  const stored = getChallenge();

  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  if (mode === "demo") {
    return <Navigate to="/login" replace />;
  }

  if (auth.status === "authenticated") {
    return <Navigate to="/" replace />;
  }

  if (!stored || stored.challengeName === "MFA_SETUP") {
    return (
      <Navigate
        to={stored?.challengeName === "MFA_SETUP" ? "/mfa/setup" : "/login"}
        replace
      />
    );
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!stored) return;
    setError(null);
    setPending(true);
    try {
      await auth.completeMfaChallenge({
        email: stored.email,
        session: stored.session,
        code: code.trim(),
      });
      navigate("/", { replace: true });
    } catch (err) {
      setError(
        err instanceof AuthApiError
          ? err.detail || "Código inválido."
          : "Falha ao validar MFA.",
      );
    } finally {
      setPending(false);
    }
  }

  return (
    <AuthLayout
      title="Verificação MFA"
      lead={`Digite o código do autenticador para ${stored.email}.`}
    >
      <form className="evolua-auth__form" onSubmit={onSubmit}>
        <Field
          label="Código de 6 dígitos"
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="[0-9]{6}"
          maxLength={6}
          required
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
        />
        {error ? <Alert tone="danger">{error}</Alert> : null}
        <Button type="submit" loading={pending} disabled={code.length !== 6}>
          Continuar
        </Button>
      </form>
      <div className="evolua-auth__links">
        <Link to="/login">Voltar ao login</Link>
        <Link to="/recuperar-senha">Recuperar acesso</Link>
      </div>
    </AuthLayout>
  );
}
